export default __webpack_public_path__ + "static/media/pechat.dbe240af.png";